module.exports = __webpack_public_path__ + "static/media/vitor-israel.368a2b69.png";